import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoaderService, MessageService } from '@shared';
import { RestaurantService, TieredRestaurant } from '@shared-data';

@Component({
  selector: 'app-set-king-restaurant',
  templateUrl: './set-king-restaurant.component.html',
  styleUrl: './set-king-restaurant.component.scss',
})
export class SetKingRestaurantComponent {
  @Input()
  restaurantToSetKing!: TieredRestaurant;

  @Output()
  onConfirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private restaurantsService: RestaurantService,
    private messageService: MessageService,
    private loaderService: LoaderService,
  ) {}

  onCancel() {
    this.onConfirm.emit(false);
  }

  onProceed() {
    this.loaderService.show();
    this.restaurantsService
      .setKingRestaurant(this.restaurantToSetKing.id)
      .subscribe({
        next: () => {
          this.onConfirm.emit(true);

          this.loaderService.hide();
        },
        error: (err) => {
          const validationError = err?.error;
          if (validationError) {
            this.messageService.error(validationError);
          } else {
            this.messageService.error('Error setting king restaurant');
          }

          this.restaurantToSetKing.isKing = false;
          this.loaderService.hide();
          this.onConfirm.emit(false);
        },
      });
  }
}
